import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the service worker and shows a small banner when a new version of
 * the app has been deployed, instead of silently serving stale cached code.
 * Clicking "Reload" activates the new service worker and reloads the page.
 */
export function setupPwaUpdates() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  const updateSW = registerSW({
    onNeedRefresh() {
      showReloadBanner(() => updateSW(true));
    },
  });
}

function showReloadBanner(onReload: () => void) {
  if (document.getElementById('pwa-update-banner')) return;

  const banner = document.createElement('div');
  banner.id = 'pwa-update-banner';
  banner.setAttribute('role', 'status');
  banner.style.cssText = [
    'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
    'z-index:2147483647', 'display:flex', 'align-items:center', 'gap:12px',
    'padding:12px 16px', 'border-radius:12px', 'background:#3F55DF', 'color:#fff',
    'font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif', 'font-size:14px',
    'box-shadow:0 8px 24px rgba(0,0,0,0.25)', 'max-width:90vw',
  ].join(';');

  const text = document.createElement('span');
  text.textContent = 'A new version is available.';

  const reloadBtn = document.createElement('button');
  reloadBtn.type = 'button';
  reloadBtn.textContent = 'Reload';
  reloadBtn.style.cssText = [
    'cursor:pointer', 'border:none', 'border-radius:8px', 'padding:6px 14px',
    'background:#fff', 'color:#3F55DF', 'font-weight:600', 'font-size:14px',
  ].join(';');
  reloadBtn.addEventListener('click', () => {
    reloadBtn.disabled = true;
    reloadBtn.textContent = 'Updating…';
    onReload();
  });

  const dismissBtn = document.createElement('button');
  dismissBtn.type = 'button';
  dismissBtn.textContent = 'Later';
  dismissBtn.setAttribute('aria-label', 'Dismiss update notification');
  dismissBtn.style.cssText = [
    'cursor:pointer', 'border:none', 'background:transparent', 'color:#fff',
    'font-size:14px', 'opacity:0.85', 'padding:6px 4px',
  ].join(';');
  dismissBtn.addEventListener('click', () => banner.remove());

  banner.append(text, reloadBtn, dismissBtn);
  document.body.appendChild(banner);
}
